module.exports = __webpack_public_path__ + "img/hld-action-bottom.5b2a0bce.png";